import { z } from 'zod'

import DataSource from 'constants/sources/DataSource'
import { WALLET_STATUS_KEY } from 'constants/WalletStatus'

export const walletChains = [
  DataSource.Arbitrum,
  DataSource.ArbitrumNova,
  DataSource.Avalanche,
  DataSource.Base,
  DataSource.BinanceSmartChain,
  DataSource.Bitcoin,
  DataSource.BitcoinCash,
  DataSource.BitcoinIaaS,
  DataSource.Cardano,
  DataSource.Dash,
  DataSource.Dogecoin,
  DataSource.EthereumIaaS,
  DataSource.Litecoin,
  DataSource.Near,
  DataSource.Optimism,
  DataSource.PolygonIaaS,
  DataSource.Proton,
  DataSource.Rootstock,
  DataSource.SolanaNew,
  DataSource.SolanaIaaS,
  DataSource.Tron,
] as const

export const zeusWalletChains = [
  DataSource.Arbitrum,
  DataSource.ArbitrumNova,
  DataSource.Avalanche,
  DataSource.Base,
  DataSource.BinanceSmartChain,
  DataSource.Bitcoin,
  DataSource.BitcoinCash,
  DataSource.Cardano,
  DataSource.Dash,
  DataSource.Dogecoin,
  DataSource.Ethereum,
  DataSource.Litecoin,
  DataSource.Near,
  DataSource.Optimism,
  DataSource.Polygon,
  DataSource.Proton,
  DataSource.Rootstock,
  DataSource.Solana,
  DataSource.Tron,
] as const

const WalletStatusKeys = z.enum(Object.keys(WALLET_STATUS_KEY) as [keyof typeof WALLET_STATUS_KEY])

const baseWalletSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  addr: z.string(),
  chain: z.enum(walletChains).or(z.string()),
  type: z.string().optional(),
  load_status: WalletStatusKeys.optional(),
  comment: z.string().optional(),
  created_at: z.string().optional(),
  org: z.string().optional(),
})

export const walletResponseSchema = baseWalletSchema.extend({
  source_tag_names: z.array(z.string()).optional(),
})

export const upsertWalletSchema = baseWalletSchema
  .extend({
    source_tags: z.array(z.string()).optional(),
  })
  .partial({
    id: true,
    chain: true,
    created_at: true,
    load_status: true,
    org: true,
    source_tags: true,
  })

export const walletArraySchema = z.array(walletResponseSchema)

const bulkWalletItemSchema = z.object({
  name: z.string(),
  chain: z.string(),
  addr: z.string(),
  type: z.string(),
  source_tags: z.array(z.string()).optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  comment: z.string().optional(),
})

export const bulkCreateWalletsRequestSchema = z.object({
  wallets: z.array(bulkWalletItemSchema),
})

const bulkResultItemSchema = z.discriminatedUnion('status', [
  z.object({
    index: z.number(),
    status: z.literal('success'),
    wallet: walletResponseSchema,
  }),
  z.object({
    index: z.number(),
    status: z.literal('error'),
    error: z.string(),
  }),
])

export const bulkCreateWalletsResponseSchema = z.object({
  results: z.array(bulkResultItemSchema),
  summary: z.object({
    total: z.number(),
    succeeded: z.number(),
    failed: z.number(),
  }),
})
